// extracted by mini-css-extract-plugin
module.exports = {"sortingWrapper":"styles_sortingWrapper__3sW8T","name":"styles_name__1Uzxx","infoIcon":"styles_infoIcon__2LGO-"};